/**
 * Справочник таможенных брокеров нетарифки (с 27.09.2026): карточка брокера и
 * привязка к ней запроса брокеру — чтобы при нескольких брокерах было видно,
 * кому ушёл какой файл. Паспорт — docs/features/nontariff.md.
 *
 * Справочник наполняется работой: обязательно только название, остальное —
 * по мере надобности; нового брокера логист добавляет прямо из окна «Отправить брокеру».
 */
import { z } from 'zod'
import { SAFE_STRING } from './request.types'

const optionalText = (max: number) => SAFE_STRING(max).trim().nullable().optional()

export const CustomsBrokerInputSchema = z.object({
  name: SAFE_STRING(200).trim().min(1, 'Укажите название брокера'),
  contactPerson: optionalText(200),
  phone: optionalText(100),
  /** Свободным текстом: у брокера бывает несколько адресов. */
  email: optionalText(200),
  note: optionalText(2000),
})
export type CustomsBrokerInput = z.infer<typeof CustomsBrokerInputSchema>

/** Правка карточки: любые поля; `hidden` — убрать из выпадашки (запросы остаются с ним). */
export const UpdateCustomsBrokerSchema = CustomsBrokerInputSchema.partial().extend({
  hidden: z.boolean().optional(),
})
export type UpdateCustomsBrokerDto = z.infer<typeof UpdateCustomsBrokerSchema>

export const CustomsBrokersQuerySchema = z.object({
  /** '1' — вместе со скрытыми (страница справочника). */
  includeHidden: z.enum(['0', '1']).default('0'),
})
export type CustomsBrokersQuery = z.input<typeof CustomsBrokersQuerySchema>

/** Сменить брокера у запроса: id карточки или null — «не указан». */
export const SetBrokerRequestBrokerSchema = z.object({
  brokerId: z.string().uuid().nullable(),
})
export type SetBrokerRequestBrokerDto = z.infer<typeof SetBrokerRequestBrokerSchema>

/** Брокер в строке журнала и в карточке запроса. */
export interface CustomsBrokerRef {
  id: string
  name: string
}

export interface CustomsBrokerDto extends CustomsBrokerRef {
  contactPerson: string | null
  phone: string | null
  email: string | null
  note: string | null
  hidden: boolean
  /** Сколько запросов брокеру отправлено этому брокеру. */
  requestsCount: number
  lastRequestAt: string | null
  createdAt: string
}
